export default "__VITE_ASSET__Ba3Jtrh9__"